import { useParams } from "react-router-dom";
import { ErrorBoundary, Suspense } from "@suspensive/react";
import { SuspenseQuery } from "@suspensive/react-query";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { PageLoadingFallback } from "@/components/suspense/loading-fallback";
import { PageErrorFallback } from "@/components/error-boundary/error-fallback";
import { PublishSplitView } from "@/components/articles/publish/publish-split-view";
import { authorFileDetailQueryOptions } from "@/hooks/use-articles";

export default function ArticlePublishPage() {
  const { fileId } = useParams<{ fileId: string }>();

  if (!fileId) {
    return (
      <div className="p-8 text-center">
        <p className="text-muted-foreground">파일 ID가 필요합니다.</p>
      </div>
    );
  }

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary onReset={reset} fallback={PageErrorFallback}>
          <Suspense fallback={<PageLoadingFallback />}>
            <SuspenseQuery {...authorFileDetailQueryOptions(fileId)}>
              {({ data }) => <PublishSplitView mode={{ kind: "create", file: data }} />}
            </SuspenseQuery>
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
